import { createAction, createActionGroup, emptyProps, props } from "@ngrx/store";
import { Project } from "../shared/Models/project-model";
import { UserModel } from "../shared/Models/user-profile";
import { User } from "oidc-client";
import { BillingSummaryFilters } from './app.state';
import { Settings } from "../shared/warehouse-models";



export const AppActions = createActionGroup({
  source: "App",
  events: {
    "Set Language": props<{ language: string }>(),
    "Set Theme": props<{ theme: string }>(),
    "Set Is Loading": props<{ isLoading: boolean }>(),
    "loadSelectableProjects": emptyProps(),
    "setCurrentProject": props<{ currentProjectId: number }>(),
    "setCurrentUser": props<{ currentUser: User }>(),
    "clearCurrentUser": emptyProps(),
  "Set Billing Summary Filters": props<{ filters: Partial<BillingSummaryFilters> }>(),
  }
});
export const AppApiActions = createActionGroup({
  source: "App API",
  events: {
    "Load Selectable Projects Success": props<{ selectableProjects: Project[] }>(),
    "Load Selectable Projects Failure": props<{ errorMessage: string }>(),
    "Load Project Settings Success": props<{ settings: Settings }>(),
  }
});
